module.exports = __webpack_public_path__ + "static/img/Group3731.663d48d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dummy/payment/Group3731.png
// module id = lnkv
// module chunks = 31